import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import { fetchPermission } from './permissionSlice';
import { RootState } from '..';
import { ListPermissionRequest } from 'src/types/orbit/Permission';

export const usePermission = () => {
  const dispatch = useAppDispatch();
  const permissionsList = useAppSelector(
    (state: RootState) => state.permissions.permissions,
  );
  const fetchPermissionsApiStatus = useAppSelector(
    (state: RootState) => state.permissions.fetchPermissionsApiStatus,
  );

  const loadPermission = useCallback(
    (data: ListPermissionRequest) => {
      dispatch(fetchPermission(data));
    },
    [dispatch],
  );

  return {
    permissionsList,
    fetchPermissionsApiStatus,
    loadPermission,
  };
};
